import React, { useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
const NavLinks = ({ scroll }) => {
  const location = useLocation();

  const handleClick = (event) => {
    const buttons = document.querySelectorAll(".link-list");
    buttons.forEach((button) => {
      button.classList.remove("text-bridgeway");
      if (!button.classList.contains("text-neutral-300")) {
        button.classList.add("text-neutral-300");
      }
    });

    if (event.target.classList.contains("text-neutral-300")) {
      event.target.classList.remove("text-neutral-300");
    }
    event.target.classList.add("text-bridgeway");
  };

  useEffect(() => {
    const buttons = document.querySelectorAll(".link-list");
    buttons.forEach((button) => {
      if (location.pathname === "/" && location.hash === "") {
        if (button.getAttribute("href") === "/#hero") {
          button.classList.add("text-bridgeway");
          button.classList.remove("text-neutral-300");
        }
      } else if (button.getAttribute("href").includes(location.hash)) {
        button.classList.add("text-bridgeway");
        button.classList.remove("text-neutral-300");
      }
    });
  }, [location]);

  return (
    <>
      <HashLink
        className="px-4 link-list font-extrabold text-neutral-300 hover:text-bridgeway focus:text-bridgeway"
        smooth
        to="/#hero"
        onClick={handleClick}
        scroll={scroll}
      >
        Home
      </HashLink>
      <HashLink
        className="px-4 link-list font-extrabold text-neutral-300 hover:text-bridgeway focus:text-bridgeway"
        smooth
        to="/#about"
        onClick={handleClick}
        scroll={scroll}
        id="about-link"
      >
        About
      </HashLink>
      <HashLink
        className="px-4 link-list font-extrabold text-neutral-300 hover:text-bridgeway focus:text-bridgeway"
        smooth
        to="/#services"
        onClick={handleClick}
        scroll={scroll}
      >
        Services
      </HashLink>
      <HashLink
        className="px-4 link-list font-extrabold text-neutral-300 hover:text-bridgeway focus:text-bridgeway"
        smooth
        to="/#clients"
        onClick={handleClick}
        scroll={scroll}
      >
        Our Clients
      </HashLink>
      <HashLink
        className="px-4 link-list font-extrabold text-neutral-300 hover:text-bridgeway focus:text-bridgeway"
        to="/contact#contact"
        onClick={handleClick}
        scroll={scroll}
      >
        Contact Us
      </HashLink>
    </>
  );
};

export default NavLinks;
